export const defaultColumnListDefault = (ctx) => {
  console.log(ctx);
  return [
    { type: 'checkbox', width: 50 },
    {
      width: 120,
      field: 'receivableSettlementNo',
      title: '结算单号',
    },
    {
      width: 120,
      field: 'receivableSettlementLineId',
      title: '结算单行号',
    },
    {
      width: 120,
      field: 'deliveryDate',
      title: '业务日期',
    },
    {
      width: 120,
      field: 'productName',
      title: '商品描述',
    },
    {
      width: 120,
      field: 'settlementQuantity',
      title: '结算数量',
    },
    {
      width: 120,
      field: 'unitName',
      title: '计量单位',
    },
    {
      width: 120,
      field: 'vehicleNo',
      title: '车牌号',
    },
    {
      field: 'originalPrice',
      title: '原币结算单价(含税)',
      width: 150,
    },
    {
      field: 'originalAmount',
      title: '原币结算金额(含税)',
      width: 150,
    },
    {
      field: 'originalAmount',
      title: '开票申请金额',
      width: 150,
    },
  ];
};
